import { useEffect } from 'react';

export default function useBackButton(onClose, active = true) {
  useEffect(() => {
    if (!active || !onClose) return;

    const handler = () => {
      onClose();
      return true; // handled
    };

    if (!window.__backButtonHandlers) {
      window.__backButtonHandlers = [];
    }

    window.__backButtonHandlers.push(handler);

    return () => {
      const index = window.__backButtonHandlers.indexOf(handler);
      if (index !== -1) {
        window.__backButtonHandlers.splice(index, 1);
      }
    };
  }, [onClose, active]);
}
